import React, {Component} from 'react'
import Radium from 'radium'
import {Link} from 'react-router'
import {extlink, outbound} from '../analytics/outbound'

export const styles = {
  navbar: {
    fontFamily: `proxima-nova,Helvetica Neue,Helvetica,Arial,sans-serif`,
    fontSize: `28pt`,
    fontWeight: 300,
    textShadow: `1pt 1pt 1pt black`,
    '@media (max-width: 500px)': {
      fontSize: `24pt`,
    },
    '@media (max-width: 320px)': {
      fontSize: `20pt`,
    },
    textDecoration: `none`,
    backgroundColor: `#222`,
    width: `100%`,
    height: `42px`,
    padding: `0px`,
    whiteSpace: `no-wrap`,
    overflow: `hidden`,
    position: `fixed`,
    top: `0px`,
    zIndex: `4000`,
    borderBottom: `1px solid #ccc`,
  },
  navcontent: {
    marginTop: `-5px`,
  },
  brand: {
    color: `white`,
    float: `left`,
    position: `relative`,
    fontSize: `28pt`,
    marginLeft: `2px`,
  },
  button: {
    marginTop: `2px`,
    marginRight: `3px`,
    fontSize: `13pt`,
  },
  link: {
    textDecoration: `none`,
    color: `white`,
    cursor: `pointer`,
  },
  sublink: {
    fontFamily: `proxima-nova,Helvetica Neue,Helvetica,Arial,sans-serif`,
    color: `#4C4CFF`,
    textDecoration: `none`,
    cursor: `pointer`,
    position: `relative`,
    marginLeft: `20px`,
  },
  collapse: {
    '@media (max-width: 500px)': {
      display: `none`,
    },
  },
}

class NavigationBar extends Component {
  render() {
    return (
      <div style={styles.navbar}><div style={styles.navcontent}>
        <div style={styles.brand}><Link style={styles.link} to="/"><i className="fa fa-lightbulb-o" aria-hidden="true"></i> IdeaFounder</Link></div>
      </div></div>
    )
  }
}

export default Radium(NavigationBar)



// WEBPACK FOOTER //
// ./src/navbar/index.js